import type { IconProps } from './types';

export const ChevronRightIcon: React.FC<IconProps> = (props) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            strokeWidth={1.5}
            {...props}
        >
            <path d="M10.499 16.9502L15.1914 12.0004L10.499 7.0507" stroke="currentColor" />
        </svg>
    );
};
